const useProceedsList = ["Home Improvement", "Debt Consolidation", "Other"];
export default useProceedsList;
